/**
 * 問題のやり方 確認モーダル
 *************************************************/
import React, { FC } from 'react';
import { Grid, Modal, Segment, Transition, Image, Button } from 'semantic-ui-react';

export interface ExampleModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  example: {
    description: string;
    imagePath: string | null;
  };
}
const ExampleModal: FC<ExampleModalProps> = ({ isOpen, setIsOpen, example }) => {
  return (
    <>
      <Transition visible={isOpen} animation="fade up" duration={500}>
        <Modal size="large" open={isOpen} onClose={() => setIsOpen(false)}>
          <Modal.Header>問題のやり方</Modal.Header>
          <Modal.Content>
            <Grid container>
              <Grid.Row>
                <Grid.Column width={16}>
                  {example.imagePath && (
                    <Image src={`${process.env.PUBLIC_URL}/image${example.imagePath}`} centered size="large" />
                  )}
                  <p
                    style={{ lineHeight: '1.7' }}
                    // 文字列に含まれる<br>タグを認識させるため、文字列をHTMLに変換
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: example.description,
                    }}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Content>
          <Modal.Actions>
            <Button negative onClick={() => setIsOpen(false)}>
              閉じる
            </Button>
          </Modal.Actions>
        </Modal>
      </Transition>
    </>
  );
};
export default ExampleModal;
